import { render, staticRenderFns } from "./ModelFormItem.vue?vue&type=template&id=0f147e51&scoped=true"
import script from "./ModelFormItem.vue?vue&type=script&lang=js"
export * from "./ModelFormItem.vue?vue&type=script&lang=js"
import style0 from "./ModelFormItem.vue?vue&type=style&index=0&id=0f147e51&prod&lang=css"
import style1 from "./ModelFormItem.vue?vue&type=style&index=1&id=0f147e51&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f147e51",
  null
  
)

export default component.exports